import React from "react";

export const Header = () => {
  return (
    <header id="header">
      <div className="hero-section">
        <div className="hero-background"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <div className="hero-content">
                <h1 className="hero-title">
                  Peak Risk Management: Cloud-Based RMIS for Compliance and Reporting
                </h1>
                <p className="hero-subtitle">
                  A next generation cloud-based RMIS for compliance and reporting. It allows organizations to manage claims, insurance, and enterprise risk from one easy-to-use dashboard. With automation, analytics, and seamless integration, the platform reduces administrative complexity and empowers strategic, data-driven risk decisions.
                </p>
                <a
                  href="#pricing"
                  className="btn btn-primary btn-lg"
                >
                  Free Trial
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
